import React from 'react';
import { Icon } from 'anf-core-react';

export default function ContextualFit({
  reviewData,
  tmntData,
  className,
  noLinkText,
  showIcon,
}) {
  const hasReviewData = reviewData?.fitRecommendation && reviewData?.showFitRecommendation;
  const linkText = hasReviewData && !noLinkText
    ? `<a href="#rating-and-reviews">${tmntData[reviewData.fitRecommendation]?.value}</a>`
    : '';

  const tmntText = hasReviewData
    ? tmntData[reviewData.fitRecommendation]?.value
    : '';

  const tmntMessage = (tmntData?.mostRecommendedWithParam?.value || '').replace('{0}', linkText || tmntText);

  if (!hasReviewData || !tmntMessage) {
    return null;
  }

  return (
    <div data-testid="contextual-fit" className={`fit-information-section-add-to-bag ${className}`}>
      {tmntData[reviewData.fitRecommendation] && (
        <>
          {showIcon && <Icon icon="size" size="s" />}
          <p className="fit-information-section__review-text" dangerouslySetInnerHTML={{ __html: tmntMessage }} />
        </>
      )}
    </div>
  );
}
